import services from '@/services';
const LOGIN_PATH = '/login';
export default {
    async getUserProvidersFromEmail(email) {
        const url = `${LOGIN_PATH}/emails/${email}/providers`
        return await services.get(url);
    },

    async loginWithEmail(email, retry, password = null) {
        let url = `${LOGIN_PATH}/emails/codes`;
        if (retry) {
            url += '?retry=true';
        }
        let headers = {};
        if (password) {
            headers['password'] = password;
        }
        return await services.post(url, { email }, null, headers);
    },

    async confirmEmailCode(code, email) {
        const url = `${LOGIN_PATH}/emails/codes/${code}`
        return await services.post(url, { code, email });
    },

    async loginWithPassword(password, email) {
        const url = `${LOGIN_PATH}/emails/${email}/passwords`
        return await services.post(url, null, null, { password });
    },

    async postActivity(uid) {
        const url = `${LOGIN_PATH}/${uid}/activities`
        return await services.post(url);
    },
    async saveUserData(user) {
        const url = `${LOGIN_PATH}/users`;
        return await services.postAsync({
            url,
            body: user,
            timeout: 10000,
            hasToken: true
        });
    },
    async getToken() {
        return await services.getToken(true);
    },
    async deleteUserConfirmation(uid) {
        const url = `${LOGIN_PATH}/${uid}/exclusions`;
        return await services.post(url, null);
    },
}